import { AxiosInstance } from 'axios';
import authHeader from './auth_header';
import axiosInstance from "./axios_instance";

const ApiPath = "/api/profile";

class ProfileService {
    private instance: AxiosInstance;
    private readonly navigate: any;

    constructor(navigate: any) {
        this.instance = axiosInstance(navigate);
        this.navigate = navigate;
    }

    async inquiry() {
        const headers = authHeader(this.navigate);
        return await this.instance.get(ApiPath, { headers });
    }
}

export default ProfileService;